import { RootState } from '../../types/root-state';
import { InstoreInitialState } from './slice';

const selectDomain = (state: RootState) => state.spl.instore || InstoreInitialState;

export const selectCategories = (state: RootState) => selectDomain(state).categories;
export const selectCategoriesNetwork = (state: RootState) => selectDomain(state).categoriesNetwork;
export const selectStores = (state: RootState) => selectDomain(state).stores;
export const selectStoresNetwork = (state: RootState) => selectDomain(state).storesNetwork;
export const selectSelectedStoreCode = (state: RootState) => selectDomain(state).selectedStoreCode;
export const selectSelectedStoreData = (state: RootState) => selectDomain(state).selectedStoreData;
